import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { EventsState } from '../../../../../../../../store/types';
import { HomepageHeader } from '../../../../../../../../types/working-model';
import Icon, { COLORS, ICONS } from '../../../../../../../general-ui/icon';
import Switch from '../../../../../../../general-ui/switch/switch';
import { Tooltip } from '../../../../../../../general-ui/tooltip/tooltip';

interface IHomepageHeaderAdvancedLayoutProps {
	module: HomepageHeader;
	onUpdate: any;
}

const HomepageHeaderAdvancedLayout: React.FC<IHomepageHeaderAdvancedLayoutProps> = ({ onUpdate }) => {
	const {
		CreateEventReducer: {
			workingEvent
		},
	} = useSelector((event: EventsState) => event);

	const [sticky, setSticky] = useState(workingEvent?.homepage?.header.is_sticky ?? false);

	function handleClick(i: any, on: boolean) {
		setSticky(on);
		onUpdate(on);
	}

	return (
		<div className="sticky-header">
			<Switch
				value={'sticky header'}
				on={sticky}
				onClick={handleClick}
			/>
			<p>Sticky header</p>
			<Tooltip tooltip="Keep header fixed to the top of the page when scrolling">
				<Icon
					name={ICONS.INFO_OUTLINE}
					color={COLORS.CYAN}
					size={14}
				/>
			</Tooltip>
		</div>
	);
};

export default HomepageHeaderAdvancedLayout;
